import { apiPost, apiPatch } from "./client";

export function postBoat(data) {
  return apiPost("/boats/", data);
}

export function patchBoat(data) {
  return apiPatch("/boats/", data);
}
